const depositFinanceClaimPattern = /^((?:P2PAY|P2P_HOSTED): DEPOSIT Finance dispatch claimed previous=)(0|[1-9][0-9]*)( target=)(0|[1-9][0-9]*)$/;
const partialDepositConfirmedPattern = /^((?:P2PAY|P2P_HOSTED): partial Deposit confirmed total=)(0|[1-9][0-9]*)$/;

function formatMinorUnits(minorUnits: string): string {
  const padded = minorUnits.padStart(3, '0');
  const whole = padded
    .slice(0, -2)
    .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  const fraction = padded.slice(-2);

  return `${whole}.${fraction} THB`;
}

export function formatP2PayDepositMessage(paymentName: unknown, message: unknown): string {
  if (typeof message !== 'string' || message.length === 0) return '-';
  if (typeof paymentName !== 'string' || paymentName.toUpperCase() !== 'P2PAY') return message;

  const financeClaim = depositFinanceClaimPattern.exec(message);
  if (financeClaim) {
    return `${financeClaim[1]}${formatMinorUnits(financeClaim[2])}${financeClaim[3]}${formatMinorUnits(financeClaim[4])}`;
  }

  const partialConfirmation = partialDepositConfirmedPattern.exec(message);
  if (partialConfirmation) {
    return `${partialConfirmation[1]}${formatMinorUnits(partialConfirmation[2])}`;
  }

  return message;
}
